import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';

import { Icon, Typography, Tooltip } from '@mui/material';
import { StoreUtil} from 'doctivity-shared/utils';
import { withRouter } from 'utils';
import { DynamicTable } from 'components';
import { favoritesByType } from 'store/actions/favoritesActions';
import { OrganizationsTabs } from './OrganizationsTabs';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  affiliatedIcon: {
    fontSize: 14,
    verticalAlign: 'text-top',
    color: theme.palette.secondary.main,
  },
});

class FavoriteOrganizationsPage extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        label: '',
        key: 'affiliated',
        style: { width: 14 },
        sortable: false,
        showFilter: false,
        format: (affiliated) => {
          if (affiliated?.length > 0) {
            return (
              <Tooltip
                placement='bottom-start'
                title={
                  <Typography
                    style={{
                      fontSize: 13,
                      fontWeight: 200,
                    }}
                  >
                    Affiliated Organization
                  </Typography>
                }
              >
                <div
                  style={{
                    width: 14,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Icon className={props.classes.affiliatedIcon}>hub</Icon>
                </div>
              </Tooltip>
            );
          }
          return <></>;
        },
      },
      {
        label: 'Name',
        key: 'name',
        fulltext: true,
      },
      {
        label: 'Type',
        key: 'facility_type',
      },
      {
        label: 'NPI',
        key: 'npi',
        type: 'npi',
        style: { minWidth: 140, verticalAlign: 'top' },
      },
      {
        label: 'City',
        key: 'primary_location.city',
        fulltext: true,
      },
      {
        label: 'State',
        key: 'primary_location.state',
        style: { width: 50 },
        filterExact: true,
        autoCapitalize: true,
      },
      {
        label: 'Claims',
        key: 'captured_claims_count',
        style: { width: 80 },
        sortable: true,
        format: (count) => {
          return (
            <div style={{ textAlign: 'right', width: '100%', paddingRight: 12 }}>
              {count ? count.toLocaleString() : ''}
            </div>
          );
        },
      },
    ];

    this.state = {
      query: {
        include: [
          {
            association: 'primary_location',
            attributes: ['id', 'city', 'state'],
          },
        ],
        order: [['name', 'ASC']],
        limit: 25,
        offset: 0,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.clientId !== prevProps.clientId ||
      this.props.userId !== prevProps.userId
    ) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch, clientId, userId } = this.props;
    const { where, include, order, limit, offset } = this.state.query;

    dispatch(favoritesByType(clientId, userId, 'Organizations', {
      where,
      include,
      order,
      limit,
      offset,
    }));
  }

  render() {
    const { classes } = this.props;

    const { query } = this.state;

    const favorites = this.props.favorites;

    let favoritesData;
    if (StoreUtil.isLoading(favorites)) {
      favoritesData = { placeholder: true, showLoading: true, showNoData: false };
    } else if (favorites.data) {
      favoritesData = {
        count: favorites.data.count,
        rows: favorites.data.rows
          .filter((row) => row.organization)
          .map((row) => row.organization),
      };
    } else {
      favoritesData = { placeholder: true, showNoData: false, showLoading: false };
    }

    return (
      <>
        <OrganizationsTabs tab='favorite_organizations' />
        <div className={classes.container}>
          <DynamicTable
            header='Favorite Organizations'
            showFilters={true}
            columns={this.columns}
            query={query}
            data={favoritesData}
            onQueryChange={this.onQueryChange}
            getRowHref={(row) => `/organizations/${row.id}`}
          />
        </div>
      </>
    );
  }

  onQueryChange = (query) => {
    if (query.where && Object.keys(query.where).length === 0) {
      delete query.where;
    }
    this.setState({ query }, this.fetchData.bind(this));
  };
}

FavoriteOrganizationsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  clientId: PropTypes.number.isRequired,
  favorites: PropTypes.object.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const { favorites } = state;
  const userId = state.user ? state.user.id : null;
  const clientId = state.app.selectedClient;

  return {
    userId,
    clientId,
    favorites: StoreUtil.get(favorites, 'by_type', `${clientId}-${userId}-Organizations`),
  };
}

const styled = withStyles(styles)(FavoriteOrganizationsPage);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as FavoriteOrganizationsPage };
